import React, { useEffect, useState } from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
import { TrustBadges } from './ui/TrustBadges';
import { PaymentMethods } from './ui/PaymentMethods';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const items = [{
    name: 'Volume 1: The Functional Foundation',
    value: '$27'
  }, {
    name: 'Volume 2: The Cross Training Bible',
    value: '$27'
  }, {
    name: 'Volume 3: Strength That Moves',
    value: '$27'
  }, {
    name: 'Volume 4: Mobility & Recovery Mastery',
    value: '$27'
  }, {
    name: 'Volume 5: Train Every Body',
    value: '$27'
  }, {
    name: 'Volume 6: The High Performance Coach',
    value: '$27'
  }, {
    name: '5 Exclusive Free Bonuses — 400+ Pages',
    value: '$82'
  }, {
    name: 'Instant PDF Access',
    value: '$18'
  }];
  return <section id="pricing" className="py-10 md:py-16 px-4 bg-[#050505] relative" data-id="element-121">
      <div className="max-w-2xl mx-auto" data-id="element-122">
        {/* Compact urgency bar */}
        <div className="flex flex-col items-center gap-2 mb-5 md:mb-6" data-id="element-123">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-1.5 rounded-full text-[11px] md:text-xs font-bold tracking-widest uppercase animate-pulse" data-id="element-124">
            Launch Price Ends Soon
          </div>
          <div className="flex items-center gap-2 font-oswald font-bold text-brand-orange text-lg md:text-xl" data-id="element-125">
            <span className="text-zinc-500 text-sm md:text-base" data-id="element-126">
              ⚡ ENDS IN:
            </span>
            <span data-id="element-127">{String(timeLeft.hours).padStart(2, '0')}</span>:
            <span data-id="element-128">{String(timeLeft.minutes).padStart(2, '0')}</span>:
            <span data-id="element-129">{String(timeLeft.seconds).padStart(2, '0')}</span>
          </div>
        </div>

        <div className="bg-zinc-900 rounded-2xl md:rounded-3xl overflow-hidden border border-zinc-800 shadow-2xl shadow-brand-blue/5" data-id="element-130">
          <div className="p-5 md:p-8" data-id="element-131">
            {/* Header badge */}
            <div className="flex justify-center mb-4" data-id="element-132">
              <span className="inline-flex items-center gap-2 bg-brand-orange/15 text-brand-orange border border-brand-orange/30 px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase box-glow-orange" data-id="element-133">
                <Star className="w-3.5 h-3.5 fill-current" data-id="element-134" /> The Complete Offer
              </span>
            </div>

            <h3 className="text-xl md:text-3xl font-bold text-center mb-1" data-id="element-135">
              UNLOCK{' '}
              <span className="text-brand-blue" data-id="element-136">FUNCTIONAL & CROSS READY</span>{' '}
              TODAY:
            </h3>
            <p className="text-center text-[11px] md:text-xs text-zinc-500 font-bold tracking-widest uppercase mb-5" data-id="element-137">
              Total Content Value
            </p>

            {/* Dense item list */}
            <div className="space-y-1.5 mb-4" data-id="element-138">
              {items.map((item, idx) => <div key={idx} className="flex items-center justify-between py-1.5 border-b border-zinc-800/40 last:border-0" data-id="element-139">
                  <div className="flex items-center gap-2 min-w-0" data-id="element-140">
                    <Check className="w-4 h-4 text-brand-blue shrink-0" data-id="element-141" />
                    <span className="text-[13px] md:text-sm text-zinc-300 truncate" data-id="element-142">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-[13px] md:text-sm text-zinc-500 line-through font-medium whitespace-nowrap ml-3" data-id="element-143">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="flex items-center justify-between py-3 border-t border-zinc-700 mb-4" data-id="element-144">
              <span className="text-base md:text-lg text-white font-oswald font-bold uppercase" data-id="element-145">
                Real Value
              </span>
              <span className="text-lg md:text-xl text-red-400 font-bold line-through" data-id="element-146">
                $235
              </span>
            </div>

            {/* Price */}
            <div className="text-center mb-5" data-id="element-147">
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-148">
                <span className="text-xl md:text-2xl text-zinc-500 line-through font-bold" data-id="element-149">
                  $235
                </span>
                <span className="inline-block bg-emerald-500/15 border border-emerald-500/40 text-emerald-400 text-xs md:text-sm font-bold px-2.5 py-1 rounded-md" data-id="element-150">
                  86% OFF
                </span>
              </div>
              <div className="text-5xl md:text-7xl font-bold text-white text-glow-blue leading-none mb-2" data-id="element-151">
                $27
              </div>
              <p className="text-zinc-400 text-xs md:text-sm" data-id="element-152">
                One-time payment · Instant access
              </p>
            </div>

            <Button fullWidth size="xl" className="mb-3" onClick={() => window.open('https://functional-cross-ready.impultienda.ar/checkout', '_self')} data-id="element-153">
              GET FUNCTIONAL & CROSS READY NOW
            </Button>

            <p className="text-center text-[11px] md:text-xs text-zinc-500 italic mb-5" data-id="element-154">
              Everything you need to coach with confidence — starting today.
            </p>

            <TrustBadges className="mb-5" data-id="element-155" />

            <p className="text-center text-[10px] md:text-xs text-zinc-500 font-bold tracking-widest uppercase mb-3" data-id="element-156">
              Accepted Payments
            </p>
            <PaymentMethods data-id="element-157" />
          </div>
        </div>
      </div>
    </section>;
}